import { useCallback, useEffect, useState, useMemo, useRef } from 'react';
import '../Analitos.scss';
import DataGrid, { Column, Button as Butt, Editing, RequiredRule, Form, SearchPanel, Toolbar, Item as ItemT, Popup as Pop, Paging, Pager } from 'devextreme-react/data-grid';
import { useApiConfiguration } from '../../../api/api.configuration';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import Popup from 'devextreme-react/popup';
import { useScreenSize } from '../../../utils/media-query';
import { Item } from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';

export const UnitMeasurementBase = ({ visible, setVisible, onUpdate }) => {
  const { isMedium, isSmall, isXSmall } = useScreenSize();
  const dataRef = useRef<DataGrid>(null);
  const { newUnitBase, setUnitBase, deleteUnitBase, getUnitsBase } = useApiConfiguration();
  const [unitBase, setUnitBases] = useState();

  const UpdataData = useCallback(() => {
    getUnitsBase().then((res) => {
      setUnitBases(res);
    });
  }, []);

  useEffect(() => {
    UpdataData();
  }, [setUnitBases]);

  const handleVisible = useCallback(() => {
    setVisible(false);
    onUpdate();
  }, [onUpdate, setVisible]);

  const customData = useMemo(() => {
    return new CustomStore({
      key: 'Umb_Id',
      load() {
        return Promise.resolve({
          data: unitBase,
        }).catch(() => {
          throw new Error('Error de carga de datos');
        });
      },
      insert: async (values) => {
        return newUnitBase({ UnidadBase: values })
          .then((res) => {
            if (res === 105) {
              UpdataData();
              dataRef.current?.instance.refresh();
            }
          })
          .catch(() => {
            throw new Error('Error insertando el tipo de muestra');
          });
      },
      update: async (key, values) => {
        const res = await setUnitBase({ Unidad: values, IdUnidadBase: key });
        if (res !== 107) throw new Error('Error actualizando la unidad de medida');
        UpdataData(); // refetch getUnitsBase → recarga fresca (load usa ese estado)
      },
      remove: (key) => {
        return deleteUnitBase({ IdUnidadBase: key })
          .then((res) => {
            if (res === 107) {
              UpdataData();
              dataRef.current?.instance.refresh();
            }
          })
          .catch(() => {
            throw new Error('Error eliminando la unidad de medida');
          });
      },
    });
  }, [unitBase]);

  const customDataSrc = useMemo(
    () =>
      new DataSource({
        store: customData,
        reshapeOnPush: true,
      }),
    [customData]
  );

  const handleDuplicate = useCallback((e: any) => {
    const rowData = e.row.data;
    if (!rowData) return;

    // Agregar nueva fila al grid
    dataRef.current?.instance.addRow();

    // Después de un pequeño delay, establecer los valores duplicados
    setTimeout(() => {
      const visibleRows = dataRef.current?.instance.getVisibleRows();
      const newRowIndex = visibleRows?.findIndex((row: any) => row.isNewRow);

      if (newRowIndex !== -1 && newRowIndex !== undefined) {
        // Establecer valores duplicados (excepto el ID)
        dataRef.current?.instance.cellValue(newRowIndex, 'Umb_Nombre', `${rowData.Umb_Nombre} - Copia`);
        dataRef.current?.instance.cellValue(newRowIndex, 'Umb_BaseConversion', rowData.Umb_BaseConversion);
      }
    }, 100);

    notify('📋 Unidad base duplicada. Complete la edición para guardar.', 'info', 3000);
  }, []);

  return (
    <div>
      <Popup width={1200} height={'50%'} fullScreen={isMedium || isSmall || isXSmall} visible={visible} onHidden={handleVisible} title={'UNIDADES DE MEDIDA BASE'} showTitle={true} showCloseButton={true}>
        <DataGrid dataSource={customDataSrc} ref={dataRef}>
          <SearchPanel visible={true} width={300} placeholder='Buscar unidades base...' />
          <Paging enabled={true} defaultPageSize={25} />
          <Pager visible={true} allowedPageSizes={[25, 50, 100, 200, 'all']} displayMode='full' showPageSizeSelector={true} showInfo={true} showNavigationButtons={true} />
          <Editing mode={isSmall || isXSmall || isMedium ? 'popup' : 'form'} allowUpdating={true} allowAdding={true} allowDeleting={true} selectTextOnEditStart={true} texts={{ saveRowChanges: 'Guardar', cancelRowChanges: 'Cancelar', deleteRow: 'Eliminar', addRow: 'Agregar' }}>
            <Pop title='Unidad de medida base' showTitle={true} fullScreen={isXSmall || isSmall} width={isMedium ? '70%' : 500} height='auto' />
            <Form colCount={1}>
              <Item dataField='Umb_Nombre' />
              <Item dataField='Umb_BaseConversion' />
            </Form>
          </Editing>
          <Toolbar>
            <ItemT name='searchPanel' />
            <ItemT name='addRowButton' />
          </Toolbar>
          <Column allowGrouping={false} caption='ID' dataField='Umb_Id' alignment='center' visible={true} allowEditing={false} />
          <Column allowGrouping={false} caption='UNIDAD' dataField='Umb_Nombre' alignment='center' visible={true} allowEditing={true}>
            <RequiredRule />
          </Column>
          <Column allowGrouping={false} caption='BASE CONVERSIÓN' visible={true} allowEditing={true} dataField='Umb_BaseConversion' alignment='center' dataType='number'>
            <RequiredRule />
          </Column>
          <Column type='buttons' caption={'ACCIÓN'} width={100}>
            <Butt name='edit' />
            <Butt name='delete' />
            <Butt icon='copy' hint='Duplicar unidad base' onClick={handleDuplicate} />
          </Column>
        </DataGrid>
      </Popup>
    </div>
  );
};
